module.exports = __webpack_public_path__ + "static/media/Loader.3601f945.gif";